'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _lighten = require('../internal/lighten');

var _lighten2 = _interopRequireDefault(_lighten);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  container: {
    zIndex: 1,
    position: 'relative'
  },
  root: {
    width: '256px',
    height: '100%',
    backgroundColor: _colors2.default.white,
    transform: 'translateX(-256px)',
    transition: 'all .3s ease-in-out',
    position: 'fixed',
    top: 0,
    left: 0
  },
  contentContainer: {
    position: 'relative',
    maxHeight: '100%',
    width: '100%',
    overflowY: 'auto'
  },
  overlay: {
    zIndex: 'initial',
    pointerEvents: 'none',
    opacity: 0,
    transition: 'opacity .3s ease-in-out'
  },
  header: {
    fontWeight: 'bolder',
    color: _colors2.default.theme,
    margin: 0,
    padding: '16px',
    borderBottom: '1px solid ' + _colors2.default.grey,
    fontSize: '16px',
    lineHeight: '16px',
    height: '48px',
    boxSizing: 'border-box'
  },
  icon: {
    position: 'absolute',
    top: '12px',
    left: '8px',
    height: '24px'
  },
  sidebar: {
    position: 'relative',
    width: '256px',
    height: '100%',
    backgroundColor: _colors2.default.white,
    overflowY: 'scroll',
    borderRight: '1px solid ' + _colors2.default.grey
  },
  footer: {
    padding: '8px',
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    position: 'absolute',
    bottom: 0,
    left: 0,
    color: (0, _lighten2.default)(_colors2.default.primaryText, 0.8),
    backgroundColor: _colors2.default.white,
    fontSize: '16px'
  }
};
module.exports = exports.default;